import '../httpservices/core/ajax.httpservice.core';

class MailboxHttpService {

    GetDoctorWithRecentList() {
        return $.get('api/Mailbox/GetDoctorWithRecentList');
    }

    GetDoctorWithSpecificServiceId(serviceId) {
        return $.get('api/Mailbox/GetDoctorWithRecentListForService/' + serviceId);
    }

    GetReassignPhysiciansList() {
        return $.get('api/Mailbox/GetReassignPhysiciansList');
    }

}

export const MailboxHttpSvc = new MailboxHttpService();